import React from "react";
import styled from "styled-components";
import {
  Box,
  FlexSection,
  FlexContainer,
  FlexDiv,
} from "@/components/Atoms/Box";
import theme from "@/foundation/Theme";
import { Typography } from "@/foundation/Typography/V2";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import Slider from "react-slick";

function AboutSetion(props) {
  const { data = {} } = props || {};
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    rows: 3,
    responsive: [
      {
        breakpoint: 1169,
        settings: {
          slidesToShow: 1.5,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1.3,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <SectionWrap>
        <Container>
          <InnerContainer>
            <LHSSection>
              <TextWrapper>
                <StyledSvgSprite
                  icon={"icon-flash-Icon"}
                  height={"56px"}
                  mb={"16px"}
                  width={"56px"}
                />
                <Title
                  mb={"16px"}
                  variant={"heading4"}
                  color={theme.colorsV2.primary.shade_800}
                  dangerouslySetInnerHTML={{
                    __html: data?.how_it_works?.title,
                  }}
                />
                <Typography
                  variant="label2"
                  color={theme.colorsV2.primary.shade_700}
                >
                  {data?.how_it_works?.subtitle}
                </Typography>
              </TextWrapper>
            </LHSSection>
            <RHSSection>
              <SliderWrapper maxWidth={"100%"}>
                <Slider {...settings}>
                  {data?.how_it_works?.listing.map((item, index) => {
                    return (
                      <Card key={index}>
                        <TitleBox
                          color={theme.colorsV2.primary.shade_700}
                          variant={"heading6"}
                          mb={"8px"}
                        >
                          <StyledSvgSprite
                            icon={"icon-asterisk"}
                            height={"16px"}
                            width={"16px"}
                            fill={theme.colorsV2.primary.shade_700}
                          />
                          {item.title}
                        </TitleBox>
                        <Typography
                          variant="label4"
                          color={theme.colorsV2.primary.shade_600}
                        >
                          {item.subtitle}
                        </Typography>
                      </Card>
                    );
                  })}
                </Slider>
              </SliderWrapper>
            </RHSSection>
          </InnerContainer>
        </Container>
      </SectionWrap>
    </>
  );
}

export default AboutSetion;

const SectionWrap = styled(FlexSection)`
  background-color: ${theme.colorsV2.shyft.cream};
  padding: 56px 0 48px;
  position: relative;
  > div {
    position: relative;
    z-index: 1;
  }
  &:before {
    position: absolute;
    background-color: ${theme.colorsV2.primary.shade_25};
    content: "";
    height: 70%;
    width: 100%;
    bottom: 0;
    z-index: 0;
  }
  @media only screen and (max-width: 1169px) {
    padding: 0;
    background-color: transparent;
    &:before {
      content: normal;
    }
  }
`;
const InnerContainer = styled(FlexDiv)``;
const Container = styled(FlexContainer)`
  flex-direction: column;
  ${InnerContainer} {
    background-color: ${theme.colors.white};
    border-radius: 24px;
    padding: 16px;
    box-shadow: 0px 10px 20px rgba(${theme.colors.shadows.black}, 0.04),
      0px 2px 6px rgba(${theme.colors.shadows.black}, 0.04),
      0px 0px 1px rgba(${theme.colors.shadows.black}, 0.04);
    @media only screen and (max-width: 1169px) {
      flex-direction: column;
    }
    @media only screen and (max-width: 1169px) {
      border-radius: 0;
      background-color: ${theme.colorsV2.gray.shade_50};
      box-shadow: none;
      padding: 0 0 8px;
    }
  }
  @media only screen and (max-width: 1169px) {
    padding: 0;
  }
`;
const LHSSection = styled(FlexDiv)`
  width: 100%;
  max-width: 384px;
  padding: 16px 32px 16px 48px;
  flex-direction: column;
  margin-right: 16px;
  justify-content: center;
  @media only screen and (max-width: 1169px) {
    max-width: 100%;
    margin-right: 0;
  }
  @media only screen and (max-width: 1169px) {
    padding: 32px;
  }
`;
const RHSSection = styled(LHSSection)`
  margin-right: 0px;
  max-width: unset;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 44px 0px;
  justify-content: flex-start;
  flex: 1;
  @media only screen and (max-width: 1169px) {
    margin: 0 auto;
    padding: 0;
  }
`;
const TextWrapper = styled(FlexDiv)`
  flex-direction: column;
`;
const Title = styled(Typography)`
  .purple_text {
    font-family: inherit;
    font-size: inherit;
    color: ${theme.colorsV2.purple.shade_600};
  }
`;
const Card = styled(FlexDiv)`
  width: 100%;
  padding: 12px 0;
  flex-direction: column;
  margin-bottom: 32px;
  @media only screen and (max-width: 1169px) {
    padding: 16px;
    background-color: ${theme.colors.white};
    border-radius: 16px;
    margin-bottom: 0;
  }
`;
const TitleBox = styled(Typography)`
  padding-left: 24px;
  position: relative;
  display: flex;
  align-items: center;
  .icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }
`;
const SliderWrapper = styled(Box)`
  width: 100%;
  margin: 0;
  .slick-track {
    display: flex !important;
  }
  .slick-slide {
    height: auto !important;
  }
  .slick-slide {
    > div {
      display: flex;
      margin: 0 40px;
      @media only screen and (max-width: 1169px) {
        margin: 0 0 16px 16px;
      }
    }
    @media only screen and (max-width: 1169px) {
      &:last-child {
        margin-right: 16px;
      }
    }
  }
  @media only screen and (max-width: 1024px) {
    margin: 0;
  }
`;
